import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

const TypingEffect = ({ text, speed = 20, onDone, id, greetingDoneHandler, message, onTyping }) => {
    const [displayed, setDisplayed] = useState("");
    const intervalRef = useRef(null);
    const hasStarted = useRef(false);
    const textRef = useRef(text); // Store the initial text

    useEffect(() => {
        // Clear any existing interval when text changes
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        // Reset state when text changes
        if (textRef.current !== text) {
            hasStarted.current = false;
            textRef.current = text;
            setDisplayed("");
        }

        if (!text || hasStarted.current) return;

        hasStarted.current = true;
        let i = 0;

        intervalRef.current = setInterval(() => {
            if (i <= text.length) {
                setDisplayed(text.slice(0, i));
                
                // Call the onTyping callback every few characters to trigger scroll
                if (onTyping && (i % 5 === 0 || i === text.length)) {
                    onTyping();
                }
                
                i++;
            } else {
                clearInterval(intervalRef.current);
                intervalRef.current = null;

                if (id === "greetAndHowTo") {
                    greetingDoneHandler?.();
                }

                if (onDone) onDone();
            }
        }, speed);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [text, onTyping]);

    // Handle message changes separately
    useEffect(() => {
        if (message?.length > 0 && intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            setDisplayed(text || "");

            if (id === "greetAndHowTo") {
                greetingDoneHandler?.();
            }

            if (onDone) onDone();
        }
    }, [message?.length]);

    return <span>{displayed}</span>;
};

TypingEffect.propTypes = {
    text: PropTypes.string,
    speed: PropTypes.number,
    onDone: PropTypes.func,
    id: PropTypes.string,
    greetingDoneHandler: PropTypes.func,
    message: PropTypes.string,
    onTyping: PropTypes.func,
};

export default TypingEffect;
